// Gọi API cùng giao thức (http/https) với chính trang đang mở, để luôn là cùng nguồn gốc
// (same-origin) — tránh hẳn việc trình duyệt phải kiểm tra CORS khi trang http gọi sang
// https (hoặc ngược lại), từng gây lỗi "Invalid CORS request" khi đi qua Caddy.
const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
const baseUrl = isHttps ? 'https://thammyhangpooh.hopto.org/' : 'http://thammyhangpooh.hopto.org:8087/';
// const baseUrl = 'http://localhost:8089/';

export default baseUrl;